<script>
    import { crossfade, fade, fly } from 'svelte/transition';

    const [send, receive] = crossfade({
		duration: 150,
		fallback: fade,
	});

    let cls;

	export let index;
	export {cls as class};
	export let id;
	export let maxWidth = 400;
</script>

<!--<div class="dialog-screen" in:fly="{{ x: 100, duration: 750 }}" out:fly="{{ x: -100, duration: 750 }}">-->
<div {id} class="dialog-screen {cls}" in:receive={{key:'dialog-screen'}} out:send={{key:'dialog-screen'}} style="max-width: {maxWidth}px;">
    <slot></slot>
</div>

<style>
    .dialog-screen {
        display: inline-block;
    }
</style>